import { NavLink as RouterNavLink } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { AppUser, useAppContext } from './AppContext';
import { ChevronDownIcon, MenuIcon} from "@heroicons/react/solid";
import { ClinicsEnum } from './common/enums';

interface UserAvatarProps {
  user: AppUser
};

function UserAvatar(props: UserAvatarProps) {
  // If a user avatar is available, return an img tag with the pic
  return <img
      src={props.user.avatar || '/images/no-profile-photo.png'} alt="user"
      className="mr-2 rounded-circle align-self-center tw-inline"
      style={{ width: '32px' }}></img>;
}

export default function NavBar() {
  const app = useAppContext();
  const user = app.user || { displayName: '', email: '' };
  const isRedirectUriCompatable = (window.location.pathname) === "/"

  const links = <>
    <Menu.Item as="div" className="tw-flex tw-flex-grow tw-flex-col md:tw-flex-row tw-items-left md:tw-items-center tw-space-y-3 md:tw-space-y-0">
      <AuthenticatedTemplate>
        <RouterNavLink to="/" activeClassName="!tw-text-gray-100" className="tw-px-0 md:tw-px-4 tw-text-gray-300 tw-no-underline hover:tw-text-gray-100" exact>Home</RouterNavLink>
        <RouterNavLink to={`/calendar?clinic=${ClinicsEnum.HOME}`} activeClassName="!tw-text-gray-100" className="tw-px-0 md:tw-px-4 tw-text-gray-300 tw-no-underline hover:tw-text-gray-100" exact>Availability</RouterNavLink>
        <RouterNavLink to="/send-availability" activeClassName="!tw-text-gray-100" className="tw-px-0 md:tw-px-4 tw-text-gray-300 tw-no-underline hover:tw-text-gray-100" exact>Send Availability</RouterNavLink>
        <RouterNavLink to="/dashboard" activeClassName="!tw-text-gray-100" className="tw-px-0 md:tw-px-4 tw-text-gray-300 tw-no-underline hover:tw-text-gray-100" exact>Dashboard</RouterNavLink>
      </AuthenticatedTemplate>
    </Menu.Item>
    <Menu.Item as="div" className="tw-inline-flex tw-items-center tw-mt-4 md:tw-mt-0 md:tw-ml-4">
      <a href="mailto:hudson15@live.unc.edu?subject=Student%20Scheduling%20Portal%20Feedback" target="_blank" rel="noreferrer" className="tw-text-gray-300 tw-mr-3 hover:tw-text-gray-100 tw-no-underline">
        Help/Feedback
      </a>

      <AuthenticatedTemplate>
        <Menu>
          <Menu.Button className="tw-inline-flex tw-items-center tw-text-gray-300 hover:tw-text-gray-100">
            <UserAvatar user={user} />
            <ChevronDownIcon
            className="tw-ml-2 -tw-mr-1 tw-h-5 tw-w-5"
            aria-hidden="true" />
          </Menu.Button>
          <Menu.Items className="tw-absolute tw-top-44 md:tw-top-12 md:tw-right-10 tw-mt-2 tw-divide-y tw-divide-gray-100 tw-rounded-md tw-bg-white tw-shadow tw-w-60">
            <Menu.Item><div className="tw-py-1 tw-font-bold tw-px-4">{user.displayName}</div></Menu.Item>
            <Menu.Item><div className="tw-py-1 tw-text-gray-400 tw-px-4">{user.email}</div></Menu.Item>
            <Menu.Item><button className="tw-py-1 tw-px-4 tw-w-full tw-text-left hover:tw-bg-gray-100" onClick={app.signOut!}>Sign Out</button></Menu.Item>
          </Menu.Items>
        </Menu>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>

      {
      isRedirectUriCompatable 
      ? <button onClick={() => app.signIn!()}>Sign In</button>
      : <RouterNavLink to="/" className="nav-link" exact>Home</RouterNavLink>
      }
      </UnauthenticatedTemplate>
    </Menu.Item>
  </>

  return (
      <Menu as="div" className="tw-bg-slate-900 tw-sticky tw-top-0 tw-z-50">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-px-20 md:tw-items-center tw-py-4 tw-max-w-screen-xl tw-mx-auto">
          <div className="tw-flex tw-flex-row tw-justify-between">
            <a href="/" className="tw-no-underline"><h1 className="tw-text-xl tw-font-semibold tw-mb-0 tw-text-white tw-flex-none tw-whitespace-nowrap">Student Scheduling Portal</h1></a>
            <Menu.Button className="tw-border tw-border-white tw-rounded md:tw-hidden tw-absolute tw-right-4">
              <MenuIcon className="tw-h-6 tw-w-6 tw-text-white tw-m-1" />
            </Menu.Button>
          </div>
          {/* MOBILE MENU */}
          <Transition
            enter="tw-transition tw-duration-300 tw-ease-out"
            enterFrom="tw-transform tw-scale-95 tw-opacity-0"
            enterTo="tw-transform tw-scale-100 tw-opacity-100"
            leave="tw-transition tw-duration-100 tw-ease-out"
            leaveFrom="tw-transform tw-scale-100 tw-opacity-100"
            leaveTo="tw-transform tw-scale-95 tw-opacity-0"
          >
            <Menu.Items className="tw-flex tw-flex-col tw-justify-between tw-w-full tw-flex-wrap md:tw-hidden">
              {links}
            </Menu.Items>
          </Transition>

          {/* DESKTOP MENU */}
          <Menu.Items className="tw-flex-row tw-justify-between tw-w-full tw-flex-wrap tw-hidden md:tw-flex" static>
            {links}
          </Menu.Items>
        </div>
      </Menu>
  );
}